export default {
  '/lease-radar': ['VENDOR'],
  '/leaser-radar/details': ['VENDOR']
}